import qs from 'qs';
import { useState } from 'react';
import { AxiosPrivate } from '../utils/axios';

export const useGetUsers = () => {
  const [isFetching, setFetching] = useState(false);
  const [userItems, setUserItems] = useState([]);
  const [userObjects, setUserObjects] = useState<any[]>([]);

  return {
    isFetching,
    userItems,
    userObjects,
    onLoad: async (organizationId?: string | null) => {
      try {
        setFetching(true);
        const { data } = await AxiosPrivate.get(`/organizations/${organizationId}/users`);

        const users = data.map(item => ({
          value: item.id,
          label: item.displayName,
          email: item.email,
        }));

        setUserItems(users);
        setUserObjects(data);
        setFetching(false);

        return users;
      } catch (e) {
        setFetching(false);
      }
    },
    getUsersFromMultipleOrgs: async (organizationIds: string[]) => {
      setFetching(true);
      const { data } = await AxiosPrivate.get(`/organizations/users/multiple`, {
        params: { organizationIds },
        paramsSerializer: params => {
          return qs.stringify(params);
        },
      });

      const users = data.map(item => ({
        value: item.id,
        label: item.displayName,
      }));

      setUserItems(users);
      setUserObjects(data);
      setFetching(false);

      return users;
    },
  };
};
